// Default palette + icon for new maps and as fallbacks.
export const DEFAULT_MAP_COLOR = '#2563EB'
export const DEFAULT_MAP_ICON = 'Map'
// Default basemap key (matches DEFAULT_BASEMAP_KEY in components/maps/basemaps.ts).
export const DEFAULT_MAP_BASEMAP = 'outdoors'

const orgMaps = (state, orgId) => state.maps[orgId] || []

export const mutations = {
  SET_MAPS (state, { orgId, maps }) {
    state.maps = { ...state.maps, [orgId]: maps }
  },

  ADD_MAP (state, { orgId, map }) {
    state.maps = { ...state.maps, [orgId]: [...orgMaps(state, orgId), map] }
  },

  UPDATE_MAP (state, { orgId, mapId, patch }) {
    state.maps = {
      ...state.maps,
      [orgId]: orgMaps(state, orgId).map(m => m.id === mapId ? { ...m, ...patch } : m)
    }
  },

  DELETE_MAP (state, { orgId, mapId }) {
    const maps = orgMaps(state, orgId)
    const target = maps.find(m => m.id === mapId)
    if (!target || target.isDefault) return
    const fallback = maps.find(m => m.isDefault)
    state.maps = {
      ...state.maps,
      [orgId]: maps
        .filter(m => m.id !== mapId)
        .map(m => m.id === fallback?.id
          ? { ...m, layerCodes: [...m.layerCodes, ...target.layerCodes] }
          : m)
    }
  },

  MOVE_LAYER_TO_MAP (state, { orgId, layerCode, mapId }) {
    state.maps = {
      ...state.maps,
      [orgId]: orgMaps(state, orgId).map(m => {
        if (m.id === mapId) {
          if (m.layerCodes.includes(layerCode)) return m
          return { ...m, layerCodes: [...m.layerCodes, layerCode] }
        }
        return { ...m, layerCodes: m.layerCodes.filter(c => c !== layerCode) }
      })
    }
  },

  // Drop a layer from every map — it falls back into the derived Unassigned map.
  DETACH_LAYER (state, { orgId, layerCode }) {
    state.maps = {
      ...state.maps,
      [orgId]: orgMaps(state, orgId).map(m => ({
        ...m,
        layerCodes: m.layerCodes.filter(c => c !== layerCode)
      }))
    }
  },

  REORDER_MAP_LAYERS (state, { orgId, mapId, layerCodes }) {
    state.maps = {
      ...state.maps,
      [orgId]: orgMaps(state, orgId).map(m => m.id === mapId ? { ...m, layerCodes: [...layerCodes] } : m)
    }
  },

  SET_MAP_MEMBERS (state, { mapId, members }) {
    state.members = { ...state.members, [mapId]: members }
  },

  UPDATE_MAP_MEMBER (state, { mapId, mapMemberId, patch }) {
    const members = state.members[mapId] || []
    state.members = {
      ...state.members,
      [mapId]: members.map(m => m.map_member_id === mapMemberId ? { ...m, ...patch } : m)
    }
  },

  REMOVE_MAP_MEMBER (state, { mapId, mapMemberId }) {
    const members = state.members[mapId] || []
    state.members = {
      ...state.members,
      [mapId]: members.filter(m => m.map_member_id !== mapMemberId)
    }
  },

  SET_MAP_INVITES (state, { mapId, invites }) {
    state.invites = { ...state.invites, [mapId]: invites }
  },

  ADD_MAP_INVITE (state, { mapId, invite }) {
    const invites = state.invites[mapId] || []
    state.invites = { ...state.invites, [mapId]: [...invites, invite] }
  },

  REMOVE_MAP_INVITE (state, { mapId, uuid }) {
    const invites = state.invites[mapId] || []
    state.invites = {
      ...state.invites,
      [mapId]: invites.filter(i => i.uuid !== uuid)
    }
  }
}
